module.exports = __webpack_public_path__ + "img/regist-method-excel.061a833a.svg";